import { cn } from "../lib/utils.js";
import { getColorScheme } from "../lib/colorSchemes.js";
import { Skeleton } from "./skeleton.js";
import { useState } from "react";
import { UserCircle } from "@phosphor-icons/react";
import { jsx } from "react/jsx-runtime";
import { reportImageLoadError } from "miter-utils/image-load-errors";
import { getWebDevicePixelRatio, pickImageVariant, withImageVariant } from "miter-utils/image-variants";
//#region src/components/avatar.tsx
const sizeStyles = {
	xs: {
		container: "tw:size-6",
		font: "tw:text-xs",
		compactFont: "tw:text-[10px]",
		icon: "tw:size-3",
		px: 24
	},
	sm: {
		container: "tw:size-8",
		font: "tw:text-sm",
		compactFont: "tw:text-xs",
		icon: "tw:size-5",
		px: 32
	},
	md: {
		container: "tw:size-12",
		font: "tw:text-base",
		compactFont: "tw:text-sm",
		icon: "tw:size-6",
		px: 48
	},
	lg: {
		container: "tw:size-16",
		font: "tw:text-lg",
		compactFont: "tw:text-base",
		icon: "tw:size-8",
		px: 64
	},
	xl: {
		container: "tw:size-20",
		font: "tw:text-2xl",
		compactFont: "tw:text-lg",
		icon: "tw:size-10",
		px: 80
	}
};
const variantStyles = {
	square: "tw:rounded-sm",
	full: "tw:rounded-full"
};
const Avatar = ({ className, size = "md", initials, imageUrl, variant = "square" }) => {
	const [hiddenUrl, setHiddenUrl] = useState(void 0);
	const showImage = !!imageUrl && hiddenUrl !== imageUrl;
	const sizedImageUrl = imageUrl ? withImageVariant(imageUrl, pickImageVariant(sizeStyles[size].px, getWebDevicePixelRatio())) : imageUrl;
	const colorScheme = initials ? getColorScheme(initials ?? "", true) : null;
	const roundedClass = variantStyles[variant];
	const classNames = cn(sizeStyles[size].container, sizeStyles[size].font, colorScheme?.background, colorScheme?.foreground, !showImage && colorScheme?.border, className);
	return /* @__PURE__ */ jsx("div", {
		className: cn("tw:box-border tw:flex tw:items-center tw:justify-center tw:font-medium tw:overflow-hidden", !showImage && "tw:new:border", roundedClass, classNames),
		children: showImage ? /* @__PURE__ */ jsx("img", {
			src: sizedImageUrl,
			alt: "Avatar",
			loading: "lazy",
			decoding: "async",
			onError: () => {
				setHiddenUrl(imageUrl);
				reportImageLoadError(sizedImageUrl, "ui2-avatar");
			},
			className: cn("tw:w-full tw:h-full tw:object-cover")
		}) : initials ? /* @__PURE__ */ jsx("span", {
			className: initials.length === 3 ? sizeStyles[size].compactFont : void 0,
			children: initials
		}) : /* @__PURE__ */ jsx(UserCircle, { className: cn(sizeStyles[size].icon) })
	});
};
const AvatarSkeleton = ({ size = "md", variant = "square", className }) => {
	return /* @__PURE__ */ jsx(Skeleton, { className: cn("tw:shrink-0", sizeStyles[size].container, variantStyles[variant], className) });
};
//#endregion
export { Avatar, AvatarSkeleton };

//# sourceMappingURL=avatar.js.map